// Tienda Colombia — scripts propios (vanilla, sin dependencias)

document.addEventListener('DOMContentLoaded', function () {
  initAlturaCarrito();
  initReveals();
  initAngulos();
  initContadores();
  initAcordeon();
  initVariantes();
  initColorBarraAnuncio();
  initMiniaturas();
  initCantidad();
  initAgregarCarrito();
  initAbrirCarrito();
  initCarruselVideos();
  initMarqueeInfinito();
  initCartTimer();
  initComparativa();
});

// ---- Altura real del carrito en móvil: Chrome cambia el alto visible al mostrar/ocultar la barra de direcciones ----
function initAlturaCarrito() {
  function actualizar() {
    document.documentElement.style.setProperty('--ml-alto-carrito', window.innerHeight + 'px');
  }
  actualizar();
  window.addEventListener('resize', actualizar);
  window.addEventListener('orientationchange', actualizar);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', actualizar);
  }
}

// ---- Cuenta atrás de urgencia en el carrito: persiste 10 min, se cancela si el carrito queda vacío ----
function initCartTimer() {
  var CLAVE = 'ml_cart_timer_inicio';
  var DURACION = 10 * 60 * 1000;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    var grupo = document.querySelector('[data-ml-cart-timer-reloj]');
    if (!grupo) {
      // No hay banner de timer visible => el carrito está vacío => cancelamos la cuenta atrás
      try { localStorage.removeItem(CLAVE); } catch (e) {}
      return;
    }

    var inicio = null;
    try { inicio = Number(localStorage.getItem(CLAVE)) || null; } catch (e) {}
    if (!inicio) {
      inicio = Date.now();
      try { localStorage.setItem(CLAVE, String(inicio)); } catch (e) {}
    }

    var restante = (inicio + DURACION) - Date.now();
    var texto = document.querySelector('[data-ml-cart-timer-texto]');

    if (restante <= 0) {
      // Se agotó el tiempo: el reloj se queda en 00:00 y cambia el mensaje, sin reiniciar la cuenta
      var m0 = grupo.querySelector('[data-ml-timer-m]');
      var s0 = grupo.querySelector('[data-ml-timer-s]');
      if (m0) m0.textContent = '00';
      if (s0) s0.textContent = '00';
      if (texto && texto.getAttribute('data-ml-texto-agotado')) {
        texto.innerHTML = texto.getAttribute('data-ml-texto-agotado');
      }
      return;
    }

    if (texto && texto.getAttribute('data-ml-texto-activo')) {
      texto.innerHTML = texto.getAttribute('data-ml-texto-activo');
    }

    var totalSeg = Math.max(0, Math.floor(restante / 1000));
    var m = grupo.querySelector('[data-ml-timer-m]');
    var s = grupo.querySelector('[data-ml-timer-s]');
    if (m) m.textContent = pad(Math.floor(totalSeg / 60));
    if (s) s.textContent = pad(totalSeg % 60);
  }

  tick();
  setInterval(tick, 1000);
}

// ---- Evita que las animaciones tipo marquee (banner de anuncio, pagos) se congelen tras estar la pestaña en segundo plano ----
function initMarqueeInfinito() {
  var tracks = document.querySelectorAll('.ml-anuncio-marquee__track, .ml-pagos-carrusel__track');
  if (!tracks.length) return;

  // Velocidad fija del banner de anuncio (px por segundo): no cambia aunque se agreguen o quiten mensajes
  var VELOCIDAD_ANUNCIO = 24;
  function ajustarVelocidad() {
    tracks.forEach(function (track) {
      if (!track.classList.contains('ml-anuncio-marquee__track')) return;
      var mitad = track.scrollWidth / 2;
      if (mitad > 0) track.style.animationDuration = (mitad / VELOCIDAD_ANUNCIO) + 's';
    });
  }

  function reiniciar() {
    tracks.forEach(function (track) {
      track.style.animation = 'none';
      void track.offsetWidth; // fuerza reflow para reiniciar el keyframe
      track.style.animation = '';
    });
    ajustarVelocidad();
  }

  ajustarVelocidad();
  window.addEventListener('load', ajustarVelocidad);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') reiniciar();
  });
  window.addEventListener('pageshow', reiniciar);
}

// ---- Color de la barra de anuncio a juego con el mensaje visible ----
function initColorBarraAnuncio() {
  var barras = document.querySelectorAll('.utility-bar');
  barras.forEach(function (barra) {
    var slides = barra.querySelectorAll('.slideshow__slide[data-ml-color-scheme]');
    if (!slides.length) return;

    var clasesConocidas = [];
    slides.forEach(function (s) {
      var clase = s.getAttribute('data-ml-color-scheme');
      if (clase && clasesConocidas.indexOf(clase) === -1) clasesConocidas.push(clase);
    });

    function activar(slide) {
      var clase = slide.getAttribute('data-ml-color-scheme');
      if (!clase) return;
      clasesConocidas.forEach(function (c) { barra.classList.remove(c); });
      barra.classList.add(clase);
    }

    activar(slides[0]);
    if (slides.length < 2 || !('IntersectionObserver' in window)) return;

    var slider = barra.querySelector('.slider');
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
          activar(entry.target);
        }
      });
    }, { root: slider, threshold: [0.6] });
    slides.forEach(function (s) { obs.observe(s); });
  });
}

// ---- Reveal al hacer scroll ----
function initReveals() {
  var els = document.querySelectorAll('.ml-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('ml-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-delay') || 0;
        setTimeout(function () { entry.target.classList.add('ml-visible'); }, Number(delay));
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

// ---- Galería de ángulos (sticky + selector + línea de progreso "carretera") ----
function initAngulos() {
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var VELOCIDAD_PX_SEG = 45; // velocidad constante de la línea, como un carro avanzando
  var secciones = document.querySelectorAll('.ml-angulos');

  secciones.forEach(function (seccion) {
    var filas = seccion.querySelectorAll('.ml-angulos__fila');
    var frames = seccion.querySelectorAll('.ml-angulos__frame');
    var lista = seccion.querySelector('.ml-angulos__lista');
    if (!filas.length || !frames.length || !lista) return;

    var animId = null;
    var ultimoTs = null;
    var progreso = 0;
    var indiceActivo = -1;

    function medirPuntos() {
      var listaTop = lista.getBoundingClientRect().top;
      return Array.prototype.map.call(filas, function (fila) {
        var num = fila.querySelector('.ml-angulos__fila-num');
        var r = num.getBoundingClientRect();
        return (r.top - listaTop) + r.height / 2;
      });
    }

    function aplicarIndice(idx) {
      if (idx === indiceActivo) return;
      indiceActivo = idx;
      filas.forEach(function (f) { f.classList.remove('ml-fila-activa'); });
      frames.forEach(function (fr) { fr.classList.remove('ml-activo'); });
      var fila = seccion.querySelector('.ml-angulos__fila[data-index="' + idx + '"]');
      var frame = seccion.querySelector('.ml-angulos__frame[data-index="' + idx + '"]');
      if (fila) fila.classList.add('ml-fila-activa');
      if (frame) frame.classList.add('ml-activo');
    }

    function detenerConduccion() {
      if (animId) { cancelAnimationFrame(animId); animId = null; }
      ultimoTs = null;
    }

    function iniciarConduccion() {
      if (reducedMotion || filas.length < 2) return;
      detenerConduccion();
      var puntos = medirPuntos();
      var gapPromedio = puntos.length > 1
        ? (puntos[puntos.length - 1] - puntos[0]) / (puntos.length - 1)
        : 100;
      // recorre un tramo extra tras el último recuadro para que su foto
      // alcance a mostrarse antes de reiniciar (1 segundo menos que las demás)
      var extraTramo = Math.max(0, gapPromedio - VELOCIDAD_PX_SEG * 1);
      var total = puntos[puntos.length - 1] + extraTramo;

      function paso(ts) {
        if (ultimoTs === null) ultimoTs = ts;
        var dt = (ts - ultimoTs) / 1000;
        ultimoTs = ts;
        progreso += VELOCIDAD_PX_SEG * dt;
        if (progreso >= total) {
          progreso = 0; // llega al final, sigue derecho y reinicia hasta la primera foto
        }
        lista.style.setProperty('--ml-progreso', progreso + 'px');
        var idx = 0;
        for (var i = 0; i < puntos.length; i++) {
          if (progreso >= puntos[i]) idx = i;
        }
        aplicarIndice(idx);
        animId = requestAnimationFrame(paso);
      }
      animId = requestAnimationFrame(paso);
    }

    filas.forEach(function (fila) {
      fila.addEventListener('click', function () {
        var puntos = medirPuntos();
        var idx = Number(fila.getAttribute('data-index'));
        progreso = puntos[idx];
        lista.style.setProperty('--ml-progreso', progreso + 'px');
        aplicarIndice(idx);
        iniciarConduccion();
      });
    });

    seccion.addEventListener('mouseenter', detenerConduccion);
    seccion.addEventListener('mouseleave', iniciarConduccion);

    aplicarIndice(0);
    lista.style.setProperty('--ml-progreso', '0px');
    if (reducedMotion) return;
    iniciarConduccion();
  });
}

// ---- Contadores animados ----
function initContadores() {
  var contadores = document.querySelectorAll('.ml-contador[data-hasta]');
  if (!contadores.length) return;
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var strong = el.querySelector('strong');
      var hasta = parseFloat(el.getAttribute('data-hasta')) || 0;
      var sufijo = el.getAttribute('data-sufijo') || '';
      if (reducedMotion) {
        strong.textContent = hasta + sufijo;
        obs.unobserve(el);
        return;
      }
      var inicio = 0;
      var duracion = 1400;
      var t0 = null;
      function paso(ts) {
        if (!t0) t0 = ts;
        var progreso = Math.min((ts - t0) / duracion, 1);
        var ease = 1 - Math.pow(1 - progreso, 3);
        var valor = inicio + (hasta - inicio) * ease;
        strong.textContent = (hasta % 1 === 0 ? Math.round(valor) : valor.toFixed(1)) + sufijo;
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
      obs.unobserve(el);
    });
  }, { threshold: 0.4 });
  contadores.forEach(function (el) { obs.observe(el); });
}

// ---- Acordeón (página de producto) ----
function initAcordeon() {
  var items = document.querySelectorAll('.ml-acordeon-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.ml-acordeon-btn');
    var panel = item.querySelector('.ml-acordeon-panel');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var abierto = item.classList.contains('ml-abierto');
      item.parentElement.querySelectorAll('.ml-acordeon-item').forEach(function (i) {
        i.classList.remove('ml-abierto');
        i.querySelector('.ml-acordeon-panel').style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('ml-abierto');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
}

// ---- Añadir al carrito por AJAX: abre el carrito lateral en vez de navegar a /cart ----
function initAgregarCarrito() {
  var wraps = document.querySelectorAll('[data-ml-producto]');
  wraps.forEach(function (wrap) {
    var form = wrap.querySelector('form[data-type="add-to-cart-form"]') || wrap.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      var btn = form.querySelector('.ml-producto__comprar-btn');
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var textoOriginal = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Añadiendo…'; }

      var formData = new FormData(form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map(function (s) { return s.id; }).join(',')
        );
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            if (btn) { btn.disabled = false; btn.textContent = textoOriginal; }
            alert(data.description || 'No se pudo añadir el producto al carrito.');
            return;
          }
          var destino = form.querySelector('input[name="return_to"]');
          if (destino && destino.value) {
            if (btn) btn.textContent = 'Redirigiendo…';
            window.location = destino.value;
            return;
          }
          if (btn) { btn.disabled = false; btn.textContent = textoOriginal; }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(data);
          } else {
            window.location = window.routes.cart_url;
          }
        })
        .catch(function () {
          form.submit();
        });
    });
  });
}

// ---- Banner de Acción: abre directamente el formulario de pago de Releasit (sin carrito de Shopify) ----
function initAbrirCarrito() {
  document.addEventListener('click', function (evt) {
    var boton = evt.target.closest('[data-ml-abrir-carrito]');
    if (!boton || boton.disabled) return;
    evt.preventDefault();
    var intentos = 0;
    (function abrir() {
      // El botón de Releasit que vive en la página (no el flotante ni el de un carrito)
      var rsi = document.querySelector(':not(#cart-wrapper):not(#floatingBuyNowButton) > #rsi_buy_now_button');
      if (rsi) { rsi.click(); return; }
      if (++intentos < 20) { setTimeout(abrir, 250); return; }
      var flotante = document.querySelector('#floatingBuyNowButton > button');
      if (flotante) flotante.click();
    })();
  });
}

// ---- Carrusel de videos 9:16: el del centro se reproduce como vista previa ----
function initCarruselVideos() {
  var carruseles = document.querySelectorAll('[data-ml-carrusel-videos]');
  carruseles.forEach(function (carrusel) {
    var pista = carrusel.querySelector('[data-ml-carrusel-pista]');
    var viewport = carrusel.querySelector('.ml-carrusel-videos__viewport');
    var items = Array.prototype.slice.call(carrusel.querySelectorAll('.ml-carrusel-videos__item'));
    var prevBtn = carrusel.querySelector('[data-ml-carrusel-prev]');
    var nextBtn = carrusel.querySelector('[data-ml-carrusel-next]');
    if (!pista || !viewport || !items.length) return;
    var indiceInicial = items.findIndex(function (item) { return item.classList.contains('ml-activo'); });
    var indiceActual = indiceInicial >= 0 ? indiceInicial : 0;

    function centrar() {
      // Medimos la distancia real entre ítems (incluye el gap), no solo el ancho del ítem
      var pitch = items.length > 1
        ? items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left
        : items[0].offsetWidth;
      var offset = viewport.offsetWidth / 2 - indiceActual * pitch - items[0].offsetWidth / 2;
      pista.style.transform = 'translateX(' + offset + 'px)';
    }

    function actualizarSonidoBtn(item, video) {
      var btn = item.querySelector('[data-ml-sonido-btn]');
      if (!btn) return;
      var off = btn.querySelector('.ml-icono-sonido-off');
      var on = btn.querySelector('.ml-icono-sonido-on');
      // Los <svg> no reflejan la propiedad .hidden de forma confiable en todos los navegadores:
      // se manipula el atributo "hidden" directamente para que el toggle funcione siempre.
      if (off) { if (!video.muted) { off.setAttribute('hidden', ''); } else { off.removeAttribute('hidden'); } }
      if (on) { if (video.muted) { on.setAttribute('hidden', ''); } else { on.removeAttribute('hidden'); } }
    }

    function actualizarActivo(esInicial) {
      items.forEach(function (item, i) {
        var video = item.querySelector('video');
        if (!video) return;
        if (i === indiceActual) {
          item.classList.add('ml-activo');
          var reproducir = function () { video.play().catch(function () {}); };
          if (esInicial) {
            // en la carga inicial no reiniciamos currentTime: puede chocar con el autoplay nativo si el video aún no tiene metadata
            if (video.readyState >= 2) reproducir();
            else video.addEventListener('loadeddata', reproducir, { once: true });
          } else {
            video.currentTime = 0;
            reproducir();
          }
        } else {
          item.classList.remove('ml-activo');
          video.pause();
          video.muted = true;
          actualizarSonidoBtn(item, video);
        }
      });
    }

    function ir(nuevoIndice) {
      indiceActual = (nuevoIndice + items.length) % items.length;
      centrar();
      actualizarActivo();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { ir(indiceActual - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { ir(indiceActual + 1); });

    items.forEach(function (item) {
      var video = item.querySelector('video');
      var sonidoBtn = item.querySelector('[data-ml-sonido-btn]');
      if (!video || !sonidoBtn) return;
      sonidoBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        actualizarSonidoBtn(item, video);
      });
    });

    window.addEventListener('resize', centrar);
    centrar();
    actualizarActivo(true);
  });
}

// ---- Miniaturas de la galería de producto ----
function initMiniaturas() {
  var grupos = document.querySelectorAll('[data-ml-miniaturas]');
  grupos.forEach(function (grupo) {
    var wrap = grupo.closest('[data-ml-producto]') || grupo.parentElement;
    var galeria = grupo.closest('.ml-producto__galeria') || grupo.parentElement;
    var modal = galeria.querySelector('[data-ml-galeria-modal]');
    var miniaturas = grupo.querySelectorAll('.ml-miniatura');

    function seleccionar(src, alt) {
      miniaturas.forEach(function (m) {
        m.classList.toggle('ml-seleccionado', m.getAttribute('data-src') === src);
      });
      mostrarMediaPrincipal(wrap, { src: src, alt: alt });
    }

    // Flechas del visor principal: para móvil, donde las miniaturas y el "+" están ocultos
    var flechaPrev = galeria.querySelector('[data-ml-galeria-prev]');
    var flechaNext = galeria.querySelector('[data-ml-galeria-next]');
    if (flechaPrev || flechaNext) {
      var lista = Array.prototype.map.call(miniaturas, function (m) {
        return { src: m.getAttribute('data-src'), alt: m.getAttribute('data-alt') };
      });
      var moverIndice = function (delta) {
        var actual = -1;
        miniaturas.forEach(function (m, idx) { if (m.classList.contains('ml-seleccionado')) actual = idx; });
        var total = lista.length;
        var nuevo = ((actual + delta) % total + total) % total;
        var item = lista[nuevo];
        if (item) seleccionar(item.src, item.alt);
      };
      if (flechaPrev) flechaPrev.addEventListener('click', function () { moverIndice(-1); });
      if (flechaNext) flechaNext.addEventListener('click', function () { moverIndice(1); });
    }

    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        if (mini.classList.contains('ml-miniatura--mas') && modal) {
          modal.hidden = false;
          return;
        }
        seleccionar(mini.getAttribute('data-src'), mini.getAttribute('data-alt'));
      });
    });

    if (modal) {
      var cerrarBtns = modal.querySelectorAll('[data-ml-galeria-modal-cerrar]');
      cerrarBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { modal.hidden = true; });
      });
      modal.querySelectorAll('.ml-galeria-modal__item').forEach(function (item) {
        item.addEventListener('click', function () {
          seleccionar(item.getAttribute('data-src'), item.getAttribute('data-alt'));
          modal.hidden = true;
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) modal.hidden = true;
      });
    }
  });
}

// ---- Selector de cantidad en la ficha de producto ----
function initCantidad() {
  var grupos = document.querySelectorAll('[data-ml-cantidad]');
  grupos.forEach(function (grupo) {
    var input = grupo.querySelector('[data-ml-cantidad-input]');
    var menos = grupo.querySelector('[data-ml-cantidad-menos]');
    var mas = grupo.querySelector('[data-ml-cantidad-mas]');
    if (!input) return;
    function ajustar(delta) {
      var min = parseInt(input.min, 10) || 1;
      var actual = parseInt(input.value, 10) || min;
      var nuevo = Math.max(min, actual + delta);
      input.value = nuevo;
    }
    if (menos) menos.addEventListener('click', function () { ajustar(-1); });
    if (mas) mas.addEventListener('click', function () { ajustar(1); });
    input.addEventListener('change', function () {
      var min = parseInt(input.min, 10) || 1;
      if (!input.value || parseInt(input.value, 10) < min) input.value = min;
    });
  });
}

// ---- Muestra una imagen en el visor principal de la galería ----
function mostrarMediaPrincipal(wrap, opciones) {
  var contenedor = wrap.querySelector('.ml-producto__galeria-principal');
  if (!contenedor) return;

  // Cada llamada invalida las anteriores: solo la última petición puede acabar en pantalla,
  // aunque las imágenes anteriores terminen de cargar después.
  var token = (contenedor._mlToken = (contenedor._mlToken || 0) + 1);

  contenedor.querySelectorAll('.ml-media-entrando').forEach(function (p) { p.remove(); });

  var visibles = contenedor.querySelectorAll('img:not(.ml-media-saliendo), video');
  var actual = visibles[visibles.length - 1];
  if (actual && actual.getAttribute('src') === opciones.src) return;

  var img = document.createElement('img');
  img.alt = opciones.alt || '';
  img.className = 'ml-media-entrando';

  var mostrar = function () {
    if (!img.classList.contains('ml-media-entrando')) return; // ya mostrada (el evento load llega tras el camino síncrono)
    if (contenedor._mlToken !== token) { img.remove(); return; }
    void img.offsetWidth; // fuerza reflow para que el navegador registre el estado inicial antes de quitarlo
    img.classList.remove('ml-media-entrando');
    contenedor.querySelectorAll('img, video').forEach(function (otro) {
      if (otro === img) return;
      otro.classList.add('ml-media-saliendo');
      setTimeout(function () { if (otro.parentNode) otro.remove(); }, 300);
    });
  };
  img.addEventListener('load', mostrar);
  img.addEventListener('error', function () { img.remove(); });
  img.src = opciones.src;
  contenedor.appendChild(img);
  if (img.complete && img.naturalWidth > 0) mostrar();
}

// ---- Selector de variantes + galería + precio ----
function initVariantes() {
  var forms = document.querySelectorAll('[data-ml-producto]');
  forms.forEach(function (wrap) {
    var dataEl = wrap.querySelector('[data-ml-variantes]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var promoCards = wrap.querySelectorAll('.ml-promo-card');
    var colorBtns = wrap.querySelectorAll('.ml-producto__valores--color .ml-opcion-valor--color');

    // "doble" no es una variante real: es un atajo de cantidad (x2) sobre la
    // variante device. seleccion.paquete guarda la tarjeta elegida (para UI y
    // bloqueo de cantidad); seleccion.promo siempre es 'device' para resolver
    // la variante a comprar.
    var seleccion = { paquete: null, promo: null, color: null };
    var promoInicial = wrap.querySelector('.ml-promo-card.ml-seleccionado');
    if (promoInicial) {
      seleccion.paquete = promoInicial.getAttribute('data-valor');
      seleccion.promo = 'device';
    }
    var colorInicial = wrap.querySelector('.ml-producto__valores--color .ml-opcion-valor--color.ml-seleccionado');
    if (colorInicial) seleccion.color = colorInicial.getAttribute('data-valor');

    function encontrarVariante() {
      if (seleccion.color === null && variantes.length === 1) return variantes[0];
      return variantes.find(function (v) {
        return v.color === seleccion.color;
      });
    }

    function actualizarCantidad() {
      var cantidadInput = wrap.querySelector('[data-ml-cantidad-input]');
      var btnMenos = wrap.querySelector('[data-ml-cantidad-menos]');
      var btnMas = wrap.querySelector('[data-ml-cantidad-mas]');
      var cantidadPaquete = 1;
      if (seleccion.paquete && seleccion.paquete !== 'device') {
        var cardCant = wrap.querySelector('.ml-promo-card[data-valor="' + seleccion.paquete + '"]');
        cantidadPaquete = (cardCant && parseInt(cardCant.getAttribute('data-cantidad'), 10)) || (seleccion.paquete === 'doble' ? 2 : 1);
      }
      var bloqueado = cantidadPaquete > 1;
      if (cantidadInput) {
        cantidadInput.value = cantidadPaquete;
      }
      if (cantidadInput) cantidadInput.readOnly = bloqueado;
      if (btnMenos) btnMenos.disabled = bloqueado;
      if (btnMas) btnMas.disabled = bloqueado;
    }

    function actualizar() {
      var variante = encontrarVariante();
      var input = wrap.querySelector('input[name="id"]');
      var btn = wrap.querySelector('.ml-producto__comprar-btn');
      if (!variante) {
        if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-texto-no-disponible') || 'No disponible'; }
        return;
      }
      if (input) input.value = variante.id;
      if (btn) {
        if (variante.disponible) {
          btn.disabled = false;
          btn.textContent = btn.getAttribute('data-texto-comprar') || 'Añadir al carrito';
        } else {
          btn.disabled = true;
          btn.textContent = btn.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
      if (variante.imagen_url) {
        mostrarMediaPrincipal(wrap, { src: variante.imagen_url });
      }
      if (seleccion.color) {
        wrap.querySelectorAll('.ml-miniatura').forEach(function (m) {
          if ((m.getAttribute('data-alt') || '').indexOf('color ' + seleccion.color) !== -1) {
            wrap.querySelectorAll('.ml-miniatura').forEach(function (o) { o.classList.remove('ml-seleccionado'); });
            m.classList.add('ml-seleccionado');
          }
        });
      }

      var precioActual = wrap.querySelector('[data-ml-precio-actual]');
      var precioAntes = wrap.querySelector('[data-ml-precio-antes]');
      var precioBadge = wrap.querySelector('[data-ml-precio-badge]');

      var esPaquete = !!seleccion.paquete && seleccion.paquete !== 'device';
      var cardPaquete = esPaquete ? wrap.querySelector('.ml-promo-card[data-valor="' + seleccion.paquete + '"]') : null;

      if (precioActual) precioActual.textContent = cardPaquete ? cardPaquete.getAttribute('data-precio-pack') : variante.precio_formateado;
      if (precioAntes) {
        var antesTexto = cardPaquete ? cardPaquete.getAttribute('data-precio-pack-antes') : variante.precio_antes_formateado;
        if (antesTexto) {
          precioAntes.textContent = antesTexto;
          precioAntes.hidden = false;
        } else {
          precioAntes.hidden = true;
        }
      }
      if (precioBadge) {
        var pct = cardPaquete ? cardPaquete.getAttribute('data-pack-ahorro-pct') : variante.ahorro_pct;
        if (pct > 0) {
          precioBadge.textContent = '-' + pct + '%';
          precioBadge.hidden = false;
        } else {
          precioBadge.hidden = true;
        }
      }
    }

    promoCards.forEach(function (card) {
      card.addEventListener('click', function () {
        promoCards.forEach(function (c) { c.classList.remove('ml-seleccionado'); });
        card.classList.add('ml-seleccionado');
        var valor = card.getAttribute('data-valor');
        seleccion.paquete = valor;
        seleccion.promo = 'device';
        actualizarCantidad();
        actualizar();
      });
    });

    colorBtns.forEach(function (btnValor) {
      btnValor.addEventListener('click', function () {
        if (btnValor.disabled) return;
        colorBtns.forEach(function (b) { b.classList.remove('ml-seleccionado'); });
        btnValor.classList.add('ml-seleccionado');
        seleccion.color = btnValor.getAttribute('data-valor');
        actualizar();
      });
    });

    actualizarCantidad();
  });
}

// ---- Comparativa interactiva "Elige con qué comparar" ----
function initComparativa() {
  var grupos = document.querySelectorAll('[data-ml-comparativa]');
  grupos.forEach(function (grupo) {
    var tabs = grupo.querySelectorAll('[data-comparar-tab]');
    var paneles = grupo.querySelectorAll('[data-comparar-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var valor = tab.getAttribute('data-comparar-tab');
        tabs.forEach(function (t) { t.classList.remove('ml-seleccionado'); });
        tab.classList.add('ml-seleccionado');
        paneles.forEach(function (panel) {
          var activo = panel.getAttribute('data-comparar-panel') === valor;
          panel.hidden = !activo;
          panel.classList.toggle('ml-seleccionado', activo);
        });
      });
    });
  });
}
